import { observer } from 'mobx-react';

import { Icon } from '@doordash/design-language';

// Hooks
import { useStores } from 'hooks/use-stores';

// Components
import { Divider } from 'components/bos-modules';
import { Typography } from 'top-component-library';

// Tracking
import { posTabsTracking } from 'integrations/segment/tracking-events';

// Styles
import Loading from '@doordash/component-loading';
import { POSInitiatedTab } from 'api/types';
import { FullscreenLoading } from 'components/order-status/ConsumerTabSummary/CloseTabView/styles';
import {
    Container,
    Logo,
    StyledPrimaryButton,
    StyledSecondaryButton,
    Tile,
    TileTitle,
} from 'pages/ClaimPOSTab/ClaimPOSTabPage/styles';

function ClaimPOSTabPage({
  onClaimTab,
  unclaimedPosOnlyTabs,
  loading,
}: {
  onClaimTab: (tab: POSInitiatedTab) => void;
  unclaimedPosOnlyTabs: POSInitiatedTab[];
  loading: boolean;
}) {
  const { hostStore, locationStore, tabStore, userStore } = useStores();
  const { assets } = hostStore;
  const { customer } = locationStore;
  const { setShowUnclaimedPosOnlyTabs } = tabStore;
  const { anonymous_user_id } = userStore.user_info;

  const numberOfPosTabsText =
    unclaimedPosOnlyTabs.length > 1 ? `There are ${unclaimedPosOnlyTabs.length} open tabs` : "There's an open tab";

  const handleStartNewTab = () => {
    setShowUnclaimedPosOnlyTabs(false);
    posTabsTracking.startNewTabButttonClick({ anonymousUserId: anonymous_user_id });
  };

  return (
    <Container>
      {loading && (
        <FullscreenLoading>
          <Loading color={Loading.Colors.Light} />
        </FullscreenLoading>
      )}

      <TileTitle>
        <Logo src={assets?.landing_page_logo} />
        <Typography.Title level={3}>Welcome to {customer.customer_name}!</Typography.Title>
      </TileTitle>
      <Tile>
        <Typography.Title level={4}>Find your tab</Typography.Title>
        <Typography.Paragraph type="secondary">
          {numberOfPosTabsText} at this table. Claim your tab to order more or close out.
        </Typography.Paragraph>
        {unclaimedPosOnlyTabs.map((posTab) => (
          <StyledPrimaryButton key={posTab.guid} onClick={() => onClaimTab(posTab)}>
            {posTab.tab_name}
            <Icon type="ChevronRight" />
          </StyledPrimaryButton>
        ))}
        <Divider className="default-bbot-template__mini-divider" dividerText="or" upperCase={false} />
        <StyledSecondaryButton type="default" onClick={handleStartNewTab} size="large">
          Start a new tab
        </StyledSecondaryButton>
      </Tile>
    </Container>
  );
}

export default observer(ClaimPOSTabPage);
